module.exports = __webpack_public_path__ + "img/dongle_connectFailed.c69e5c01.svg";